import {
  formatCurrency,
  formatDate,
  ITableColumn,
  ITableDataItem,
} from "@inceptionbg/ui-components";
import { FC, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IFieldEntry } from "../../types/IFieldBook";
import { getFieldEntries } from "../../repos/FIeldBookRepo";
import { Table } from "../../Components/CustomIUI/Table/Table";

interface Props {
  fieldUuid: string;
  setSelectedItem: (e: Partial<IFieldEntry>) => void;
  actionButton: any;
}

export const FieldBookEntriesTable: FC<Props> = ({
  fieldUuid,
  setSelectedItem,
  actionButton,
}) => {
  const [entries, setEntries] = useState<IFieldEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const handleGetEntries = useCallback(() => {
    if (fieldUuid) {
      setIsLoading(true);
      getFieldEntries(fieldUuid, [
        "PLANT_CULTURE",
        "ACTIVITY",
        "LABOR_TYPE",
        "TREATMENT_AGENT",
        "FIELD",
      ])
        .then((data) => setEntries(data.entries))
        .catch(() => {})
        .finally(() => setIsLoading(false));
    }
  }, [fieldUuid]);

  useEffect(handleGetEntries, [handleGetEntries]);

  const columns: ITableColumn[] = [
    { id: "activityDate", label: t("Date") },
    { id: "plantCulture", label: t("PlantCultureC") },
    { id: "type", label: t("EntryType") },
    { id: "activityGroup", label: t("ActivityGroup") },
    { id: "activity", label: t("ActivityWorks") },
    { id: "incomeOrCosts", label: t("IncomeOrCosts") },
  ];

  const data: ITableDataItem[] = entries.map((e) => ({
    uuid: e.uuid,
    onRowClick: () =>
      setSelectedItem({
        ...e,
        activityGroup: e.activity?.activityGroup,
        laborTypeGroup: e.laborType?.laborTypeGroup,
        pricePerUnit:
          !!e.income && !!e.quantity ? String(+e.income / +e.quantity) : "",
      }),
    cells: {
      type: { value: t(e.type) },
      plantCulture: {
        value: e.plantCulture
          ? e.plantCulture?.code + " - " + e.plantCulture?.name
          : "",
      },
      activityDate: { value: formatDate(e.activityDate) },
      activityGroup: { value: e.activity?.activityGroup?.name || "" },
      activity: { value: e.activity?.name || "" },
      incomeOrCosts: { value: formatCurrency(e.income || e.expense) },
    },
  }));

  return !!entries.length ? (
    <div className="my-5">
      <div className="flex justify-right"> {actionButton}</div>

      <h2>{t("Activities")}:</h2>
      <Table data={data} columns={columns} isLoading={isLoading} headerWrap />
    </div>
  ) : null;
};
